import React from "react";
import PropTypes from "prop-types";

import withStyles from '@mui/styles/withStyles';

import QualificationComponent from './QualificationComponent';
import { ReclamationQualificationDetailType } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';

import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';

import QualificationTextField from 'components/Shared/QualificationTextField';

import QualificationAccordionSummary from './QualificationAccordionSummary';

const prisesEnCharge = [
    "Réparation sous-garantie",
    "Réparation hors garantie FORFAIT",
    "Réparation hors garantie DEVIS",
];


const forfaits = [
    "Code forfait fabricant - OPTION 1",
    "Montant maximum de réparation à indiquer au fabricant - OPTION 2",
];




const styles = theme => ({
    row: {
        flexBasis: '100%',
        marginBottom: '10px'
    },

    formControl: {
        margin: theme.spacing(1)
    },

    group: {
        margin: theme.spacing(1, 0)
    },
});

class SavByFoussierPriseEnCharge extends QualificationComponent {


    constructor(props) {
        super(props);


        this.state = {
            ...this.state,

            [ReclamationQualificationDetailCodes.SavByFoussierPriseEnCharge]: '',
            [ReclamationQualificationDetailCodes.SavByFoussierForfait]: '',
            [ReclamationQualificationDetailCodes.SavByFoussierCodeForfaitFoussier]: '',
            [ReclamationQualificationDetailCodes.SavByFoussierCodeFabricant]: '',
            [ReclamationQualificationDetailCodes.SavByFoussierMontantMaximumReparation]: '',
        };

        this.generableCodes = [
            ReclamationQualificationDetailCodes.SavByFoussierPriseEnCharge,
            ReclamationQualificationDetailCodes.SavByFoussierForfait,
            ReclamationQualificationDetailCodes.SavByFoussierCodeForfaitFoussier,
            ReclamationQualificationDetailCodes.SavByFoussierCodeFabricant,
            ReclamationQualificationDetailCodes.SavByFoussierMontantMaximumReparation
        ];
    }


    componentDidMount() {
        const { name } = this.props;
        const { position, toAdd, toDelete } = this.getQualificationData(this.state);

        this.props.onChange(name, position, toAdd, toDelete, "Mount");

    }




    getQualificationData(newState) {
        const { name } = this.props;

        // Préparation des codes à supprimer (tous les codes générables)
        let toDelete = [...this.generableCodes];


        if (newState[ReclamationQualificationDetailCodes.SavByFoussierPriseEnCharge] === ''
            || (newState[ReclamationQualificationDetailCodes.SavByFoussierPriseEnCharge] === '1' && newState[ReclamationQualificationDetailCodes.SavByFoussierForfait] === '')
            || (newState[ReclamationQualificationDetailCodes.SavByFoussierPriseEnCharge] === '1' && newState[ReclamationQualificationDetailCodes.SavByFoussierForfait] === '0' && newState[ReclamationQualificationDetailCodes.SavByFoussierCodeFabricant] === '')
            || (newState[ReclamationQualificationDetailCodes.SavByFoussierPriseEnCharge] === '1' && newState[ReclamationQualificationDetailCodes.SavByFoussierForfait] === '1' && newState[ReclamationQualificationDetailCodes.SavByFoussierMontantMaximumReparation] === '')
        ) {
            return {
                name: name,
                position: this.props.position,
                toAdd: null,
                toDelete: toDelete
            };
        }



        let toAdd = [];

        toAdd.push({
            //position: toAdd.length,
            position: 0,
            code: ReclamationQualificationDetailCodes.SavByFoussierPriseEnCharge,
            type: ReclamationQualificationDetailType.ChoixSimple,
            libelle: "Prise en charge",
            valeurInteger: newState[ReclamationQualificationDetailCodes.SavByFoussierPriseEnCharge],
            valeurString: prisesEnCharge[newState[ReclamationQualificationDetailCodes.SavByFoussierPriseEnCharge]],
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.SavByFoussierPriseEnCharge);


        //if (newState[ReclamationQualificationDetailCodes.SavByFoussierPriseEnCharge] === '0') { }

        if (newState[ReclamationQualificationDetailCodes.SavByFoussierPriseEnCharge] === '1') {

            toAdd.push({
                //position: toAdd.length,
                position: 0,
                code: ReclamationQualificationDetailCodes.SavByFoussierForfait,
                type: ReclamationQualificationDetailType.ChoixSimple,
                libelle: "Forfait",
                valeurInteger: newState[ReclamationQualificationDetailCodes.SavByFoussierForfait],
                valeurString: forfaits[newState[ReclamationQualificationDetailCodes.SavByFoussierForfait]],
            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.SavByFoussierPriseEnCharge);

            if (newState[ReclamationQualificationDetailCodes.SavByFoussierForfait] === '0') {

                toAdd.push({
                    position: 0,
                    code: ReclamationQualificationDetailCodes.SavByFoussierCodeFabricant,
                    type: ReclamationQualificationDetailType.Texte,
                    libelle: forfaits[0],
                    valeurString: newState[ReclamationQualificationDetailCodes.SavByFoussierCodeFabricant],
                });
                toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.SavByFoussierCodeFabricant);

            }

            if (newState[ReclamationQualificationDetailCodes.SavByFoussierForfait] === '1') {

                toAdd.push({
                    position: 0,
                    code: ReclamationQualificationDetailCodes.SavByFoussierMontantMaximumReparation,
                    type: ReclamationQualificationDetailType.Texte,
                    libelle: forfaits[1],
                    valeurString: newState[ReclamationQualificationDetailCodes.SavByFoussierMontantMaximumReparation],
                });
                toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.SavByFoussierMontantMaximumReparation);
            }

            if (newState[ReclamationQualificationDetailCodes.SavByFoussierCodeForfaitFoussier]) {

                toAdd.push({
                    position: 0,
                    code: ReclamationQualificationDetailCodes.SavByFoussierCodeForfaitFoussier,
                    type: ReclamationQualificationDetailType.Texte,
                    libelle: "Code forfait Foussier",
                    valeurString: newState[ReclamationQualificationDetailCodes.SavByFoussierCodeForfaitFoussier],
                });
                toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.SavByFoussierCodeForfaitFoussier);
            }

        }


        if (newState[ReclamationQualificationDetailCodes.SavByFoussierPriseEnCharge] === '2') {

            if (newState[ReclamationQualificationDetailCodes.SavByFoussierCodeForfaitFoussier]) {

                toAdd.push({
                    position: 0,
                    code: ReclamationQualificationDetailCodes.SavByFoussierCodeForfaitFoussier,
                    type: ReclamationQualificationDetailType.Texte,
                    libelle: "Code forfait Foussier",
                    valeurString: newState[ReclamationQualificationDetailCodes.SavByFoussierCodeForfaitFoussier],
                });
                toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.SavByFoussierCodeForfaitFoussier);
            }
        }






        return {
            name: name,
            position: this.props.position,
            toAdd: toAdd,
            toDelete: toDelete
        }
    }



    subComponentSousGarantie = () => {

        return null;
    };

    subComponentCodeForfaitFoussier = () => {

        return (
            <div style={{ marginLeft: '42px' }}>
                <QualificationTextField
                    label={"Code forfait fabricant"}
                    name={ReclamationQualificationDetailCodes.SavByFoussierCodeFabricant}
                    value={this.state[ReclamationQualificationDetailCodes.SavByFoussierCodeFabricant]}
                    onChange={this.handleChange}
                    required
                />
            </div>
        );
    };


    subComponentMontantMaximum = () => {

        return (
            <div style={{ marginLeft: '42px' }}>

                <QualificationTextField
                    label={"Montant maximum de réparation à indiquer au fabricant"}
                    name={ReclamationQualificationDetailCodes.SavByFoussierMontantMaximumReparation}
                    value={this.state[ReclamationQualificationDetailCodes.SavByFoussierMontantMaximumReparation]}
                    onChange={this.handleChange}
                    required
                    placeholder={"Saisir le montant"}
                />

            </div>
        );
    };


    subComponentHorsGarantieForfait = () => {

        const { classes } = this.props;

        let subComponents = [this.subComponentCodeForfaitFoussier, this.subComponentMontantMaximum];

        return (
            <div style={{ marginLeft: '42px' }}>


                <QualificationTextField
                    label={"Code forfait foussier"}
                    name={ReclamationQualificationDetailCodes.SavByFoussierCodeForfaitFoussier}
                    value={this.state[ReclamationQualificationDetailCodes.SavByFoussierCodeForfaitFoussier]}
                    onChange={this.handleChange}
                />

                <FormControl component="fieldset" style={{ width: '100%' }}>
                    <FormLabel component="legend">{ }</FormLabel>
                    <RadioGroup id={ReclamationQualificationDetailCodes.SavByFoussierForfait} name={ReclamationQualificationDetailCodes.SavByFoussierForfait} className={classes.group} value={this.state[ReclamationQualificationDetailCodes.SavByFoussierForfait]} onChange={this.handleChange}>
                        {forfaits.map((reponse, index) => (


                            <div key={index}>
                                <FormControlLabel value={index.toString()} control={<Radio />} label={reponse} />

                                {index.toString() === this.state[ReclamationQualificationDetailCodes.SavByFoussierForfait] && (

                                    subComponents[index]()

                                )}
                            </div>

                        ))}
                    </RadioGroup>
                </FormControl>
            </div>
        );


    };


    subComponentHorsGarantieDevis = () => {

        return null;
    };




    render() {
        const { name, classes } = this.props;

        //const { designation, designationDisabled } = this.state;

        let subComponents = [this.subComponentSousGarantie, this.subComponentHorsGarantieForfait, this.subComponentHorsGarantieDevis];

        return (


            <Accordion id={name} defaultExpanded={true} elevation={3}>

                <QualificationAccordionSummary title="Prise en charge" />

                <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>


                    <FormControl component="fieldset" className={classes.formControl}>
                        <FormLabel component="legend">{ }</FormLabel>
                        <RadioGroup id={ReclamationQualificationDetailCodes.SavByFoussierPriseEnCharge} name={ReclamationQualificationDetailCodes.SavByFoussierPriseEnCharge} className={classes.group} value={this.state[ReclamationQualificationDetailCodes.SavByFoussierPriseEnCharge]} onChange={this.handleChange}>
                            {prisesEnCharge.map((reponse, index) => (
                                <div key={index}>
                                    <FormControlLabel value={index.toString()} control={<Radio />} label={reponse} />

                                    {index.toString() === this.state[ReclamationQualificationDetailCodes.SavByFoussierPriseEnCharge] && (

                                        subComponents[index]()

                                    )}
                                </div>
                            ))}
                        </RadioGroup>
                    </FormControl>

                </AccordionDetails>
            </Accordion>

        );
    }

}


SavByFoussierPriseEnCharge.propTypes = {
    name: PropTypes.string.isRequired,
};

//SavByFoussierPriseEnCharge.defaultProps = {
//};

export default withStyles(styles)(SavByFoussierPriseEnCharge);